import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';
import { useEffect, useState } from 'react';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import { useWebpOrJpg } from '../../hooks/useWebpOrJpg';

const J: React.FC = () => {
    const { t } = useLang('ats.J');
    const webpOrJpg = useWebpOrJpg('#smart-gateway-J');
    const [titleHeight, setTitleHeight] = useState(0);
    /** 动画 */
    useEffect(() => {
        const dom: HTMLElement | null = document.querySelector(`.smart-gateway-J .item-title-1`);
        setTitleHeight(dom?.offsetHeight || 0);
        const title = document?.querySelector('.smart-gateway-J .title');
        const list = document?.querySelector('.smart-gateway-J .list');
        const ani1 = AniContainer.create({
            triggerElement: '.smart-gateway-J .title',
            triggerHook: 1,
            offset: '20%',
            duration: '100%',
            onEnter: () => {
                title?.classList.add('enter');
                list?.classList.add('enter');
            },
            onProcess: (process: number) => {
                if (process <= 0) {
                    title?.classList.remove('enter');
                    list?.classList.remove('enter');
                }
            },
        });
        return () => {
            ani1.destroy?.();
        };
    }, []);

    return (
        <>
            <EcoSpace />
            <section
                className={`${css.section} smart-gateway-J GtmModuleData-section`}
                id="smart-gateway-J"
                data-section-id={'smart-gateway-J'}
                data-section-title={t('title')}
            >
                <div className="title ani-1">{t('title')}</div>
                <div className="list ani-2">
                    <div className="item">
                        <div className="item-img">
                            <EcoImg
                                pc={webpOrJpg(
                                    'https://websiteoss.ecoflow.com/upload/image/1760001499850/pc_For%20DIY%20solar.jpg',
                                    'https://websiteoss.ecoflow.com/upload/image/1760001786201/pc_For.webp',
                                )}
                                h5={webpOrJpg(
                                    'https://websiteoss.ecoflow.com/upload/image/1760001499575/m_For%20DIY%20solar.jpg',
                                    'https://websiteoss.ecoflow.com/upload/image/1760001786680/m_For.webp',
                                )}
                            />
                        </div>

                        <div className="item-title item-title-1">
                            {t.rich('item1_title', {
                                s: (v: string) => <span className="sub">{v}</span>,
                            })}
                        </div>
                        <div className="item-desc">{t('item1_desc')}</div>
                    </div>
                    <div className="item">
                        <div className="item-img">
                            <EcoImg
                                pc={webpOrJpg(
                                    'https://websiteoss.ecoflow.com/upload/image/1760091293010/atspc_Compatible%20with%20Rooftop.jpg',
                                    'https://websiteoss.ecoflow.com/upload/image/1760091429983/atspc_Compatible.webp',
                                )}
                                h5={webpOrJpg(
                                    'https://websiteoss.ecoflow.com/upload/image/1760091292742/atsm_Compatible%20with%20Rooftop.jpg',
                                    'https://websiteoss.ecoflow.com/upload/image/1760091429894/atsm_Compatible.webp',
                                )}
                            />
                        </div>

                        <div className="item-title" style={{ minHeight: titleHeight }}>
                            {t.rich('item2_title', {
                                sub: (v: string) => <span className="sub">{v}</span>,
                            })}
                        </div>
                        <div className="item-desc">{t('item2_desc')}</div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default J;
